import app from './app';
import empiria from './empiria';
import topBanner from './top-banner';

export default {
    topBanner,
    empiria,
    app,
} as const;
